import styles from "./LicenseKeysModal.module.scss";
import close from "../../../assets/icons/close.svg";
import { useTranslation } from "react-i18next";
import { ILicenses } from "../../../types/details-api-types";

import CopyToClipboard from "../../CopyToClipboard/CopyToClipboard";
import { trackEvent } from "../../../utils/analytics";
import { EVENT_NAMES } from "../../../types/event-names";
import { useEffect } from "react";

interface LicenseKeysModalProps {
  setIsLicenseModalVisible: (arg: boolean) => void;
  data: ILicenses[];
}

const LicenseKeysModal: React.FC<LicenseKeysModalProps> = ({ setIsLicenseModalVisible, data }) => {
  const { t } = useTranslation();

  const { activeLicenses, inactiveLicenses, expiredLicenses } = data.reduce(
    (acc, license) => {
      const expirationDate = new Date(license.expiration_date);
      const today = new Date();

      // Check if the license is expired
      if (expirationDate < today) {
        acc.expiredLicenses.push(license);
      } else if (!license.active) {
        acc.activeLicenses.push(license);
      } else {
        acc.inactiveLicenses.push(license);
      }

      return acc;
    },
    {
      activeLicenses: [],
      inactiveLicenses: [],
      expiredLicenses: [], // Initialize expiredLicenses
    } as {
      activeLicenses: ILicenses[];
      inactiveLicenses: ILicenses[];
      expiredLicenses: ILicenses[];
    }
  );

  useEffect(() => {
    trackEvent(EVENT_NAMES.LICENSE_KEYS_OPENED, { data });
  }, [data]);

  return (
    <div className={styles.root}>
      <div className={styles.root_header}>
        <p className={styles.root_header_title}>{t("License Keys")}</p>
        <div className={styles.root_header_imgBlock}>
          <img
            className={styles.root_header_img}
            src={close}
            alt="close"
            onClick={() => setIsLicenseModalVisible(false)}
          />
        </div>
      </div>

      {/* ready for use */}
      {inactiveLicenses.length > 0 && (
        <div>
          <p className={styles.root_subtitle}>{t("Ready For Use")}</p>

          <div className={styles.root_copyWrapper}>
            {inactiveLicenses.map((license, i) => (
              <>
                <span key={i}>
                  <CopyToClipboard text={license.license_key} />
                </span>
              </>
            ))}
          </div>
        </div>
      )}

      {/* used keys */}
      {activeLicenses.length > 0 && (
        <div>
          <p className={styles.root_subtitle}>{t("Used Keys")}</p>

          <div className={styles.root_copyWrapper}>
            {activeLicenses.map((license, i) => (
              <>
                <span key={i}>
                  <CopyToClipboard text={license.license_key} />
                </span>
              </>
            ))}
          </div>
        </div>
      )}

      {/* expired keys */}
      {expiredLicenses.length > 0 && (
        <div>
          <p className={styles.root_subtitle}>{t("Expired Keys")}</p>

          <div className={styles.root_copyWrapper}>
            {expiredLicenses.map((license, i) => (
              <>
                <span key={i}>
                  <CopyToClipboard text={license.license_key} />
                </span>
              </>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default LicenseKeysModal;
